// Editar con Estudio desde el lienzo — ADR-2026-09-24-editar-con-estudio-en-la-barra-del-lienzo.
//
// Lo mismo que "Editar con estudio" del visor de Creaciones (`handleEditWithStudio` en
// GeneratedImagesHistory): crea un proyecto NUEVO en el Estudio de Video con este video
// ya en la timeline y navega. El gating (plan, escritorio, la intro la primera vez) y la
// creación viven en `useAbrirVideoEnEstudio`, compartido con la tarjeta `ir_al_estudio`
// del chat (ADR-2026-10-11-ir-al-estudio-desde-el-chat). No tiene hoja propia: el
// "panel" son esos avisos y un cartel mientras se copia el video.

import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { estadoDesdeRedes, recordarProyectoDeRedes, sesionDeRedes } from '../../../lib/estudioDesdeRedes';
import type { PropsDeHerramienta } from './herramienta';
import { AvisosDeAbrirEnEstudio, useAbrirVideoEnEstudio } from './useAbrirVideoEnEstudio';

export const PanelEditarConEstudio: React.FC<PropsDeHerramienta> = ({ celda, onCerrar, onError }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const empezado = useRef(false);

  const { paso, abrir, cerrarAviso, confirmarIntro } = useAbrirVideoEnEstudio({
    companyId: celda.companyId,
    onAbierto: (projectId) => {
      // Desde una sesión de Redes, el proyecto queda recordado para esa sesión y el
      // editor sabe volver a ella (ADR-2026-10-05-el-estudio-desde-redes-queda-a-mano).
      const sesion = sesionDeRedes(pathname);
      if (sesion) {
        recordarProyectoDeRedes(sesion, projectId);
        navigate(`/editor-video/${projectId}`, { state: estadoDesdeRedes(pathname) });
      } else {
        navigate(`/editor-video/${projectId}`);
      }
    },
    onNoAbierto: (_motivo, mensaje) => {
      if (mensaje) onError(mensaje);
      onCerrar();
    },
  });

  // Arranca una vez, al montar.
  useEffect(() => {
    if (empezado.current) return;
    empezado.current = true;
    const fileName = celda.datos.fileName;
    if (!fileName) {
      onError('No pudimos abrir este video.');
      onCerrar();
      return;
    }
    void abrir({ fileName, name: celda.titulo || undefined });
  }, [abrir, celda.datos.fileName, celda.titulo, onCerrar, onError]);

  return <AvisosDeAbrirEnEstudio paso={paso} onCerrar={cerrarAviso} onConfirmarIntro={confirmarIntro} />;
};
